import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export const getProjectAttachment = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getProjectAttachments${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const insertProjectAttachments = (myFile, query, token) => {
  let qs = buildQuery(query);
  return axios.post(`${baseUrl}/insertProjectAttachment${qs}`, myFile, {
    headers: {
      authorization: token,
    },
  });
};
export const getDownloadProjectAttachmentsFile = (id, token) => {
  // let qs = buildQuery(query);
  let url = `${baseUrl}/getDownloadProjectAttachment/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
export const deleteProjectAttachment = (id, token) => {
  let url = `${baseUrl}/deleteProjectAttachment/${id}`;
  return axios.delete(url, {
    headers: {
      authorization: token,
    },
  });
};
